var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loading
        ? _c("lazy-img", {
            attrs: {
              "image-url": _vm.imageItem,
              "picture-class": _vm.pictureClass,
              alt: "propertyUrl",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }